import { useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faBell, faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../hooks/useAuth";
import { useLembretes } from "../context/LembretesContext";
import WorkspaceSwitcher from "./WorkspaceSwitcher";
import TimerBadge from "./TimerBadge";
import "./Header.css";

const Header = ({ onToggleSidebar  }) => {
  const { dark, toggleTheme } = useContext(ThemeContext);
  const { user } = useAuth();
  const { resumo } = useLembretes();

  const initials = useMemo(() => {
    const fallback = "US";
    const rawName = user?.nome || user?.name || user?.email || "";
    const parts = rawName.trim().split(/\s+/).filter(Boolean);

    if (parts.length === 0) return fallback;
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();

    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }, [user]);

  function getSaudacao() {
    const hora = new Date().getHours();
    if (hora < 12) return "Bom dia";
    if (hora < 18) return "Boa tarde";
    return "Boa noite";
  }

  return (
    <div className="header">

      <div className="header-left">
        <button className="icon-btn" onClick={onToggleSidebar}>
          <FontAwesomeIcon icon={faBars} />
        </button>

        <Link to="/dashboard" className="app-name" aria-label="Ir para dashboard">
          LevelUp <span>ToDo</span>
        </Link>
      </div>

      <div className="header-center">
        <div className="header-center-content">
          <span>{getSaudacao()}</span>
          <WorkspaceSwitcher compact />
        </div>
      </div>

      <div className="header-right">
        {/* Cronometro rodando precisa ser visivel de qualquer tela. */}
        <TimerBadge />

        <Link
          to="/lembretes"
          className={`lembretes-atalho ${resumo.vencidos > 0 ? "tem-vencido" : ""}`}
          aria-label={
            resumo.abertos > 0
              ? `Lembretes: ${resumo.abertos} aberto(s)`
              : "Lembretes"
          }
          title="Lembretes"
        >
          <FontAwesomeIcon icon={faBell} />

          {resumo.abertos > 0 && (
            <span className="lembretes-atalho-badge">
              {resumo.abertos > 99 ? "99+" : resumo.abertos}
            </span>
          )}
        </Link>

        <button className="icon-btn" onClick={toggleTheme}>
          <FontAwesomeIcon icon={dark ? faSun : faMoon} />
        </button>

        <Link
          to="/perfil"
          className="avatar-link"
          aria-label="Abrir perfil"
          title="Ir para perfil"
        >
          <div className="avatar">{initials}</div>
        </Link>
      </div>

    </div>
  );
};

export default Header;
